import { useEffect, useState } from 'react';
import { api } from '../lib/api';

// Lightweight in-memory cache so we don't refetch /settings on every page change.
let _cache = null;
let _bankCache = null;
let _pendingSettings = null;
let _pendingBanks = null;
// Subscribers pattern so that Inline-edit saves propagate to every mounted usePublicSettings caller
const _subs = new Set();

export function usePublicSettings() {
  const [settings, setSettings] = useState(_cache || {});
  useEffect(() => {
    _subs.add(setSettings);
    if (!_cache && !_pendingSettings) {
      _pendingSettings = api.publicSettings()
        .then(d => { _cache = d || {}; return _cache; })
        .catch(() => { _cache = {}; return _cache; });
    }
    if (_pendingSettings) _pendingSettings.then(d => setSettings(d));
    return () => _subs.delete(setSettings);
  }, []);
  return settings;
}

/** Optimistically update the settings cache after an admin inline-save.
 *  All mounted usePublicSettings consumers will re-render with the new value. */
export function patchPublicSettings(patch) {
  _cache = { ...(_cache || {}), ...(patch || {}) };
  _subs.forEach(setter => setter(_cache));
}

export function usePublicBankAccounts() {
  const [banks, setBanks] = useState(_bankCache || []);
  useEffect(() => {
    if (_bankCache) return;
    if (!_pendingBanks) {
      _pendingBanks = api.publicContent('bank_accounts')
        .then(list => {
          _bankCache = (list || []).map(it => ({ id: it.id, ...(it.data || {}) }));
          return _bankCache;
        })
        .catch(() => { _bankCache = []; return _bankCache; });
    }
    _pendingBanks.then(setBanks);
  }, []);
  return banks;
}
